module.exports = __webpack_public_path__ + "static/media/goods_bg.1d919028.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/goods_bg.png
// module id = 414
// module chunks = 0